import type { EventName } from "@lit/react";
import { Upload as UploadElement, type UploadEventMap as _UploadEventMap, } from "@vaadin/upload/vaadin-upload.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { UploadElement, };
export type UploadEventMap = Readonly<{
    onFileReject: EventName<_UploadEventMap["file-reject"]>;
    onFileRemove: EventName<_UploadEventMap["file-remove"]>;
    onFilesChanged: EventName<_UploadEventMap["files-changed"]>;
    onMaxFilesReachedChanged: EventName<_UploadEventMap["max-files-reached-changed"]>;
    onUploadAbort: EventName<_UploadEventMap["upload-abort"]>;
    onUploadBefore: EventName<_UploadEventMap["upload-before"]>;
    onUploadError: EventName<_UploadEventMap["upload-error"]>;
    onUploadProgress: EventName<_UploadEventMap["upload-progress"]>;
    onUploadRequest: EventName<_UploadEventMap["upload-request"]>;
    onUploadResponse: EventName<_UploadEventMap["upload-response"]>;
    onUploadRetry: EventName<_UploadEventMap["upload-retry"]>;
    onUploadStart: EventName<_UploadEventMap["upload-start"]>;
    onUploadSuccess: EventName<_UploadEventMap["upload-success"]>;
}>;
const events = { onFileReject: "file-reject", onFileRemove: "file-remove", onFilesChanged: "files-changed", onMaxFilesReachedChanged: "max-files-reached-changed", onUploadAbort: "upload-abort", onUploadBefore: "upload-before", onUploadError: "upload-error", onUploadProgress: "upload-progress", onUploadRequest: "upload-request", onUploadResponse: "upload-response", onUploadRetry: "upload-retry", onUploadStart: "upload-start", onUploadSuccess: "upload-success" } as UploadEventMap;
export type UploadProps = WebComponentProps<UploadElement, UploadEventMap>;
export const Upload = createComponent({
    elementClass: UploadElement, events, react: React, tagName: "vaadin-upload"
});
